import { loadLocale } from 'mastodon/locales';
import main from 'mastodon/main';
import { loadPolyfills } from 'mastodon/polyfills';

// Cache-bust marker. The entry chunk's filename is content-hashed, so changing
// this value gives the entry a new filename every deploy. Without it the entry
// filename is stable across builds and Cloudflare keeps serving an old,
// immutably-cached entry whose lazy-chunk map points at stale code — so new
// frontend changes (which live in lazy chunks) never reach the browser. Bump
// this with the release number on every build (see link_footer.tsx).
const BUILD_RELEASE = '7.33';
(window as unknown as { __build: string }).__build = BUILD_RELEASE;

loadPolyfills()
  .then(loadLocale)
  .then(main)
  .catch((e: unknown) => {
    console.error(e);
  });
